import axios from 'axios'

export function forwardGeocoding(text, accessToken) {
  return axios.get('https://api.mapbox.com/geocoding/v5/mapbox.places/' + text + '.json', {
    params: { access_token: accessToken, country: 'AT' },
  })
}

export function reverseGeocoding(coordinates, accessToken) {
  return axios.get(
    'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
      coordinates[0] +
      ',' +
      coordinates[1] +
      '.json',
    {
      params: { access_token: accessToken, country: 'AT' },
    }
  )
}
